import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderBottom: `1px solid ${theme.palette.common.white}`,
    '&.theme-dark': {
      borderBottom: `1px solid ${theme.palette.grey.light}`,
    },
  },
  input: {
    color: theme.palette.common.white,
    fontFamily: theme.typography.h1.fontFamily,
    flex: 1,
    fontSize: 20,
    paddingBottom: theme.spacing(1),
    '& > input::placeholder': {
      opacity: 1,
      fontFamily: theme.typography.fontFamily,
      fontSize: 16,
    },
    '& :-ms-input-placeholder': {
      opacity: 1,
    },
    '.theme-dark &': {
      color: theme.palette.common.black,
      '& > input::placeholder': {
        color: theme.palette.grey.dark,
      },
    },
  },
  iconButton: {
    padding: theme.spacing(1),
    color: theme.palette.common.white,
    '.theme-dark &': {
      color: theme.palette.grey.dark,
    },
  },
  dropdown: {
    border: `1px solid ${theme.palette.grey.light}`,
    boxShadow: `0 8px 20px 0 ${theme.palette.action.disabledBackground}`,
  },
  tabs: {
    marginTop: theme.spacing(1),
  },
}))

export default useStyles
